import React from "react";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

type Props = DropdownWithoutOptionsProps<server.dto.ContactSmallV2>;

const ContactV2PaginatedDropdown = (props: Props) => {
  const fetchContacts = async (search: string, page: number) => {
    const res = await window.CoreApi.Contact.PaginatedSmall({
      excludeKeys: props.excludeKeys ?? [],
      keyword: search,
      page,
      perPage: 10
    });

    return res;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}

    fetchOptions={fetchContacts}
    getLabel={v => v.name.fullName}
    getValue={v => v.contactId}
    getSubLabel={v => v.position}
    config={props.config}
    value={props.value}
    onChange={props.onChange}
  />;
};

export default ContactV2PaginatedDropdown;